import { render, staticRenderFns } from "./offer.vue?vue&type=template&id=2ca80e8d&"
import script from "./offer.vue?vue&type=script&lang=js&"
export * from "./offer.vue?vue&type=script&lang=js&"
import style0 from "./offer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports